export default "__VITE_ASSET__CF6vtBIQ__"